import { AppState } from '../../common/configuration/app.states';

export const getUserSettingsState = (state: AppState) => state.userSettings.userSettings;
